import axiosInstance from '../main/axios';
import { toastr } from 'react-redux-toastr';
import { initialize } from 'redux-form';
import { showTabs, selectTab } from '../common/tab/tabActions';
import configLocal from '../configuracao/configLocal';

const INITIAL_VALUES = () => ({
  // controlador_id: 0,
  controlador_id: configLocal.getConfig('cont'),
  grupo: configLocal.getConfig('grupo'),
  status: 1,
  numero_intervalo: 4,
  modo_operacao_id: '',
  imageLog: '',
});

export function getList() {
  var numCont = configLocal.getConfig('numCont');
  var grupo = configLocal.getConfig('grupo');
  const request = axiosInstance.get(`/planos/controlador/numero/${numCont}/${grupo}`);

  return {
    type: 'PLANOCONTROLADOR_FETCHED',
    payload: request,
  };
}

export const setPaginaAtual = pagina => ({
  type: 'PLANO_PAGE',
  payload: pagina,
});

export function getListCodigo(controladorId) {
  // Se não receber o ID do controlador, tenta pegar do configLocal
  const contId = controladorId || configLocal.getConfig('cont');

  // Se não tiver ID do controlador, não faz a chamada
  if (!contId) {
    return {
      type: 'PLANOCODIGO_FETCHED',
      payload: Promise.resolve({ data: [] }),
    };
  }

  const request = axiosInstance.get(`/planos/codigo/${contId}`);

  return {
    type: 'PLANOCODIGO_FETCHED',
    payload: request,
  };
}

export function getControladorList() {
  const request = axiosInstance.get(`/controladores`);

  return {
    type: 'CONTROLADOR_FETCHED',
    payload: request,
  };
}

export function getModoOperacaoList() {
  const request = axiosInstance.get(`/planos/modoop`);

  return {
    // tem que criar um reducer para percorrer o objeto e achar o MODOOPERACAO_FETCHED com isso ele pega a propriedade "data"
    type: 'MODOOPERACAO_FETCHED',
    payload: request,
  };
}

// Nova função para buscar tabelas de troca vinculadas a um plano
export function getTabelasTrocaPlano(planoId) {
  const contId = configLocal.getConfig('cont');
  const request = axiosInstance.get(`/trocaplanos/${contId}/plano/${planoId}`);

  return {
    type: 'TABELAS_TROCA_PLANO_FETCHED',
    payload: request,
  };
}

// Nova função para excluir múltiplas tabelas de troca
export function excluirTabelasTroca(ids) {
  return async dispatch => {
    try {
      // Primeiro: Excluir tabelas do banco de dados
      await axiosInstance.delete('/trocaplanos/multiple', { data: { ids } });

      // Segundo: Enviar lista atualizada para o controlador físico
      const contId = configLocal.getConfig('cont');
      const trocasAtualizadas = await axiosInstance.get(`/trocaplanos/${contId}`);
      const listaTrocas = trocasAtualizadas.data || [];

      // Enviar para o controlador físico (mesma lógica do botão "Enviar para esse Controlador")
      if (listaTrocas.length >= 0) {
        // Permite enviar lista vazia para limpar o controlador
        await axiosInstance.put(`/trocasplanoremote/${contId}`, listaTrocas);
      }

      return { success: true };
    } catch (e) {
      console.log(e.response.data);
      if (e.response && e.response.data && e.response.data.errors) {
        e.response.data.errors.forEach(error => toastr.error('Erro', error));
      } else {
        toastr.error('Erro', 'Falha ao excluir tabelas de troca e atualizar controlador.');
      }
      return { success: false, error: e.response.data };
    }
  };
}

export function limpa(values) {
  // Usar o controlador_id do plano específico, não o configurado localmente
  var contId = values.controlador_id;
  var planoId = values.id;

  return async dispatch => {
    try {
      // Primeiro: Limpar o plano do controlador físico
      await axiosInstance.put(`/planos/limpa/${contId}/${planoId}`, values);

      // Segundo: Excluir o plano do banco de dados
      await axiosInstance.delete(`/planos/${contId}/${planoId}`, values);

      toastr.success('Sucesso', 'Plano excluído do sistema e do controlador com sucesso.');
      dispatch(init());
    } catch (e) {
      console.log(e.response.data);
      if (e.response && e.response.data && e.response.data.errors) {
        e.response.data.errors.forEach(error => toastr.error('Erro', error));
      } else {
        toastr.error('Erro', 'Falha ao excluir o plano.');
      }
    }
  };
}

export function create(values) {
  return submit(values, 'post');
}

export function update(values) {
  return submit(values, 'put');
}

export function remove(values) {
  return submit(values, 'delete');
}

function submit(values, method) {
  values['grupo_fisico_id'] = configLocal.getConfig('grupo');
  values['numero_controlador'] = configLocal.getConfig('numCont');
  values['anel'] = configLocal.getConfig('anel');

  return async dispatch => {
    const id = values.id ? values.id : '';
    const controlador_id = values.controlador_id ? values.controlador_id : '';

    await axiosInstance[method](`/planos/${controlador_id}/${id}`, values)
      .then(resp => {
        toastr.success('Sucesso', 'Operação Realizada com sucesso.');
        if (id) {
          dispatch(init());
        }
      })
      .catch(e => {
        console.log(e.response.data);
        e.response.data.errors.forEach(error => toastr.error('Erro', error));
      });
  };
}

export function showIntervalo(plano) {
  return [initialize('planoIntervalo', plano), selectTab('tabIntervalo'), showTabs('tabIntervalo')];
}

export function showUpdate(plano) {
  return [showTabs('tabUpdate'), selectTab('tabUpdate'), initialize('planoForm', plano)];
}

export function showDelete(plano) {
  return [showTabs('tabDelete'), selectTab('tabDelete'), initialize('planoForm', plano)];
}

export function init() {
  return [
    showTabs('tabList', 'tabCreate'),
    selectTab('tabList'),
    getList(),
    getListCodigo(), // se tirar isso ele não atualiza o combo de codigo de plano quando excluir um registro
    initialize('planoForm', INITIAL_VALUES()),
  ];
}

// Tipos de Action para o novo fluxo de salvar configuração completa
export const PLANO_CONFIG_SAVE_START = 'PLANO_CONFIG_SAVE_START';
export const PLANO_CONFIG_SAVE_SUCCESS = 'PLANO_CONFIG_SAVE_SUCCESS';
export const PLANO_CONFIG_SAVE_ERROR = 'PLANO_CONFIG_SAVE_ERROR';
export const PLANO_SYNC_START = 'PLANO_SYNC_START';
export const PLANO_SYNC_SUCCESS = 'PLANO_SYNC_SUCCESS';
export const PLANO_SYNC_ERROR = 'PLANO_SYNC_ERROR';

// Action que o frontend vai chamar — uma única requisição processa todos os anéis no backend.
export function sincronizarConfiguracaoCompleta(configuracoesPorAnel) {
  return async dispatch => {
    if (!configuracoesPorAnel || configuracoesPorAnel.length === 0) {
      toastr.warning('Atenção', 'Nenhuma configuração de anel para sincronizar.');
      return;
    }

    dispatch({ type: PLANO_SYNC_START });

    try {
      const resp = await axiosInstance.post('/planos/controlador/sincronizar-configuracao-completa', {
        configuracoesPorAnel,
        imageLog: configuracoesPorAnel[0] && configuracoesPorAnel[0].imageLog,
      });

      dispatch({ type: PLANO_SYNC_SUCCESS });
      toastr.success('Sucesso!', resp.data.message || 'Todos os anéis foram sincronizados com sucesso.');
    } catch (error) {
      dispatch({ type: PLANO_SYNC_ERROR, payload: error });
      if (error.response && error.response.data && error.response.data.errors) {
        error.response.data.errors.forEach(err => toastr.error('Erro', err));
      } else {
        toastr.error('Erro', 'Falha ao sincronizar configuração dos anéis.');
      }
      throw error;
    }
  };
}

// Action para salvar a configuração de UM anel
export function salvarConfiguracaoCompletaControlador(configuracaoCompletaPayload, options = {}) {
  const { silent = false } = options;

  return dispatch => {
    dispatch({ type: PLANO_CONFIG_SAVE_START, meta: { controladorId: configuracaoCompletaPayload.controlador_id } });

    return axiosInstance
      .post('/planos/controlador/salvar-configuracao-completa', configuracaoCompletaPayload)
      .then(resp => {
        dispatch({
          type: PLANO_CONFIG_SAVE_SUCCESS,
          payload: resp,
        });
        if (!silent) {
          toastr.success('Sucesso', resp.data.message || 'Configuração salva com sucesso!');
        }
      })
      .catch(e => {
        dispatch({
          type: PLANO_CONFIG_SAVE_ERROR,
          payload: e.response || e.message || e,
        });
        if (e.response && e.response.data && e.response.data.errors) {
          e.response.data.errors.forEach(error => toastr.error('Erro', error));
        } else if (e.response && e.response.data && e.response.data.message) {
          toastr.error('Erro', e.response.data.message);
        } else {
          toastr.error('Erro', 'Falha ao salvar configuração para este anel/controlador.');
        }
        console.error('Erro em salvarConfiguracaoCompletaControlador action:', e.response || e.message || e);
        throw e;
      });
  };
}
